import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Row } from "primereact/row";
import { ColumnGroup } from "primereact/columngroup";
import { getSessionStore } from "app/utils/sessionStore";
import { THEME } from "app/utils/types";

interface ColumnDefinition {
  field: string; // Field name in the data
  header: string; // Header text for the column
  formatter?: (value: any, options: any, rowData?: any) => string; // Optional formatter function
  style?: React.CSSProperties; // Optional style for the column
  frozen?: boolean;
  key?: string;
}
interface InsuredTableProps {
  data: any[]; // Array of data objects
  columns: ColumnDefinition[]; // Array of column definitions
  hoverColor: string; // Dynamic hover color
  columnGroup?: React.ReactNode;
  scrollable?: boolean;
  scrollHeight?: string;
  className?: string;
}
const InsuredTable: React.FC<InsuredTableProps> = ({
  data,
  columns,
  hoverColor,
  columnGroup,
  scrollable,
  scrollHeight,
  className = null,
}) => {
  const globalTheme = getSessionStore("globalTheme") as THEME;
  const isDark = globalTheme === THEME.DARK;

  const headerColumnGroup = columnGroup ? (
    <ColumnGroup>
      {columnGroup}
      <Row
        style={{
          border: `0.5px solid lightgray`,
        }}
        className="yunus"
      >
        {columns?.map((col) => (
          <Column
            key={col.field + (col.key ?? "")}
            field={col.field}
            header={col.header}
            {...(col.frozen && { frozen: true })}
            style={{
              ...col.style,
              background: isDark ? "#000 !important" : "#EBEBEF !important",
            }}
            // headerStyle={{
            //   borderRightWidth: 1,
            //   borderRightColor: "var(--surface-100)",
            // }}
            align="center"
          />
        ))}
      </Row>
    </ColumnGroup>
  ) : null;
  return (
    <div className="">
      <DataTable
        value={data}
        scrollable={scrollable}
        scrollHeight={scrollHeight}
        tableStyle={{ minWidth: "65rem" }}
        className="p-datatable-striped insured-table"
        headerColumnGroup={headerColumnGroup}
        showGridlines
      >
        {columns.map((col) => (
          <Column
            key={col.field + (col.key ?? "")}
            field={col.field}
            header={col.header}
            {...(col.frozen && { frozen: true })}
            style={{ ...col.style }}
            // headerStyle={{ borderRightWidth: 1, borderRightColor: "var(--surface-100)" }}
            align="center"
            body={(rowData, options) => {
              const value = rowData[col.field];
              const formattedValue = col.formatter ? col.formatter(value, options, rowData) : value;
              return <div className="insured-row">{formattedValue}</div>;
            }}
          />
        ))}
      </DataTable>
      <style>
        {`
      .insured-table .p-datatable-tbody > tr.p-row-odd {
        background: ${isDark ? "#2A2A3D" : "#FFFFFF"} !important;
      }
      .insured-table .p-datatable-tbody > tr {
        background: ${isDark ? "#3A3A50" : "#EBEBEF"} !important;
      }
      .insured-table .p-datatable-tbody > tr:hover {
        color: ${hoverColor};
        background-color: ${hoverColor}12!important;
      }
      .insured-table .p-datatable-tbody > tr:hover .p-frozen-column {
        background-color: ${hoverColor}!important;
        color: #ffffff!important;
      }
      .insured-table .p-datatable-tbody > tr > td {
        padding: 0.5rem !important;
      }
      .insured-table .p-datatable-thead > tr > th {
        padding: 0.6rem !important;
      }
      .insured-table .p-datatable-thead > tr:nth-child(2) > th:not(.p-sortable-column.p-highlight) {
        background: ${isDark ? "#2A2A3D" : "#F7F7F8"} !important;
      }
      ${className}
    `}
      </style>
    </div>
  );
};
export default InsuredTable;
